/**
 * Shared CSRF token helpers for API requests.
 */

export const csrfToken = () => {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
};

const csrfHeaders = () => {
  const token = csrfToken();
  return token ? { 'X-CSRF-Token': token } : {};
};

export default csrfHeaders;
